import { useState } from 'react';
import { API_BASE } from '../client/config';
import { Logo } from '../components/Logo';
import { Button, Field } from '../components/ui';
import { describePasswordError, PASSWORD_REUSE_HINT } from '../labels/passwordErrors';

export function ChangePassword({ onComplete }: { onComplete: () => void }): JSX.Element {
  const [current, setCurrent] = useState(''); const [password, setPassword] = useState(''); const [confirm, setConfirm] = useState('');
  const [pending, setPending] = useState(false); const [error, setError] = useState<string | null>(null);
  const valid = [...password].length >= 10 && new TextEncoder().encode(password).length <= 72 && password === confirm && password !== current && !!current;
  return <div className="flex min-h-screen items-center justify-center bg-bg px-6 py-12 text-text">
    <section className="w-full max-w-md rounded-xl border border-line bg-panel p-8 shadow-lg">
      <Logo />
      <h1 className="mt-7 text-2xl font-semibold">비밀번호를 변경해 주세요</h1>
      <p className="mt-3 text-sm leading-6 text-text-dim">처음 받은 비밀번호를 변경한 뒤 관리자 기능을 사용할 수 있습니다. 새 비밀번호는 10자 이상으로 설정해 주세요.</p>
      <form className="mt-6 space-y-4" onSubmit={event => {
        event.preventDefault(); if (!valid || pending) return;
        setPending(true); setError(null);
        void fetch(`${API_BASE}/api/account/password`, { method: 'POST', credentials: 'include', headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ currentPassword: current, newPassword: password }) })
          .then(async response => {
            if (!response.ok) { const body = await response.json().catch(() => ({})); throw new Error(describePasswordError(body.error)); }
            setCurrent(''); setPassword(''); setConfirm(''); onComplete();
          }).catch(cause => setError(cause.message)).finally(() => setPending(false));
      }}>
        <Field label="현재 비밀번호" type="password" autoComplete="current-password" value={current} disabled={pending} onChange={event => setCurrent(event.target.value)} />
        <Field label="새 비밀번호" type="password" autoComplete="new-password" value={password} disabled={pending} onChange={event => setPassword(event.target.value)} />
        <Field label="새 비밀번호 확인" type="password" autoComplete="new-password" value={confirm} disabled={pending} onChange={event => setConfirm(event.target.value)} />
        {password && password === current && <p className="text-sm text-red">{PASSWORD_REUSE_HINT}</p>}
        {confirm && password !== confirm && <p className="text-sm text-red">새 비밀번호가 일치하지 않습니다.</p>}
        {error && <p role="alert" className="text-sm text-red">{error}</p>}
        <Button type="submit" variant="primary" className="w-full" disabled={!valid || pending}>{pending ? '변경 중…' : '비밀번호 변경'}</Button>
        <Button type="button" className="w-full" disabled={pending} onClick={() => { void fetch(`${API_BASE}/api/auth/logout`, { method: 'POST', credentials: 'include' }).then(onComplete); }}>로그아웃</Button>
      </form>
    </section>
  </div>;
}
